// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"0292f6ad","383":"aa81c293","412":"a4998033","541":"43240428","586":"02eec9f5","610":"866d54fd","631":"91de689d","813":"da10a54a","840":"0ac6495f"}[chunkId] + ".chunk.js";
};